import { render, staticRenderFns } from "./userview.vue?vue&type=template&id=225c5f21"
import script from "./userview.vue?vue&type=script&lang=js"
export * from "./userview.vue?vue&type=script&lang=js"
import style0 from "./userview.vue?vue&type=style&index=0&id=225c5f21&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports